import React, { PropsWithChildren } from 'react';
import BodyRegular from 'components/Typography/BodyRegular';
import Button from 'components/DesignSystem/Button';
import './index.scss';

interface SnackbarProps {
  actionText?: string
  closeButton?: boolean
  onClose?: () => void
  onAction?: () => void
  actionOnASecondLine?: boolean
  id?: string | undefined
  className?: string
  variant?: string
}

export default function Snackbar({
  children,
  actionText = '',
  closeButton = false,
  onClose = () => { },
  onAction = () => { },
  actionOnASecondLine = false,
  id = undefined,
  className = '',
  variant = 'primary',
}: PropsWithChildren<SnackbarProps>) {
  return (
    <div
      className={`ds-snackbar-container ds-snackbar-${variant} ${className}`}
      id={id}
    >
      <div className="d-flex align-items-center">
        <div className="flex-grow-1">
          <BodyRegular>{children}</BodyRegular>
        </div>
        {!actionOnASecondLine && actionText && (
          <Button
            type="tertiary"
            onClick={onAction}
            className="ms-2 ds-snackbar-button px-1"
          >
            {actionText}
          </Button>
        )}
        {closeButton && (
          <Button icon="close" type="tertiary" onClick={onClose} className="ms-2 ds-snackbar-button" />
        )}
      </div>
      {actionOnASecondLine && actionText && (
        <div className="d-flex flex-row-reverse">
          <Button
            type="tertiary"
            onClick={onAction}
            className="mt-2 ds-snackbar-button px-1"
          >
            {actionText}
          </Button>
        </div>
      )}
    </div>
  );
}
